export default {
  namespaced: true,
  state: {
    current_order: null,
    tickets: [],
    counter_profile: 0,
    topic_options: [],
    contact_options: null,
    success_message: '',
  },
  actions: {
    GetOrderView({ rootGetters, dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('orders/api/order/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'current_order', value: response.data.item });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetChatTickets({ rootGetters, dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('chats/extranet/nolog/get-my-chats', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'tickets', value: response.data.tickets });
              commit('setField', { name: 'counter_profile', value: response.data.counter_profile });
              commit('setField', { name: 'topic_options', value: response.data.topic_options });
              commit('setField', { name: 'contact_options', value: response.data.contact_options });
              commit('setField', { name: 'success_message', value: response.data.success_message });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    AddChatMessage({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('chats/extranet/messages/add', payload)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    SetChatMessagesRead({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('chats/extranet/messages/readed-by-profile', payload)
          .then(() => { resolve(true); })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreChat({ commit }) {
      commit('setField', { name: 'current_order', value: null });
      commit('setField', { name: 'tickets', value: [] });
      commit('setField', { name: 'counter_profile', value: 0 });
      commit('setField', { name: 'topic_options', value: [] });
      commit('setField', { name: 'contact_options', value: null });
      commit('setField', { name: 'success_message', value: '' });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
